import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initCapacitor } from "@/lib/capacitor";
import { ThemeProvider } from "@/components/brand/ThemeProvider";

// Initialize Capacitor plugins only inside the native wrapper (no-op on web)
initCapacitor();

const rootEl = document.getElementById("root");
const app = (
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// Use hydrateRoot when react-snap pre-rendered the page (rootEl already has children),
// so React reuses the static HTML instead of wiping and re-rendering.
if (rootEl.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootEl, app);
} else {
  ReactDOM.createRoot(rootEl).render(app);
}
